import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "12",
      cy: "12",
      r: "11.5",
      fill: "#FFDB2E",
      stroke: "#000"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      "fill-rule": "evenodd",
      d: "M11.808 14.229c-.644 0-.84-.178-.858-.713L10.77 6.54c-.018-.535.214-.713.858-.713h.983c.643 0 .876.178.858.713l-.179 6.977c-.018.535-.214.713-.858.713zM10.77 16.563c0-.827.553-1.4 1.35-1.4.798 0 1.35.573 1.35 1.4 0 .826-.552 1.4-1.35 1.4-.797 0-1.35-.574-1.35-1.4",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }